<template>
  <div class="card">
    <div class="card-header">
      <h5>Affiliate Report</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <div>
            <label for="affiliate" class="form-label"> Affiliate </label>
            <v-select
              :options="affiliates"
              label="name"
              class="m-0"
              id="affiliate"
              index="id"
              v-model="reportFilters.affiliate.selectedAffiliate"
            />
            <small class="text-danger" v-if="reportFilters.affiliate.error">{{ reportFilters.affiliate.error }}</small>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <h6>Departure Date Range</h6>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <div>
                <dateTimePicker
                  no-label
                  label="From date"
                  id="booking_date"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  v-model="reportFilters.departureDates.from_date.date"
                  :only-date="true"
                  button-color="#ec391e"
                  color="#ec391e"
                  style="border: 1px solid #DFE5F9"
                />
                <small class="text-danger" v-if="reportFilters.departureDates.from_date_error">{{ reportFilters.departureDates.from_date_error }}</small>
              </div>
            </div>
            <div class="col-md-6">
              <div>
                <dateTimePicker
                  no-label
                  label="To date"
                  id="booking_date"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  v-model="reportFilters.departureDates.to_date.date"
                  :only-date="true"
                  button-color="#ec391e"
                  color="#ec391e"
                  style="border: 1px solid #DFE5F9"
                  :min-date="reportFilters.departureDates.from_date.date"
                />
                <small class="text-danger" v-if="reportFilters.departureDates.to_date_error">{{ reportFilters.departureDates.to_date_error }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <h6>Booking Date Range</h6>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <div>
                <dateTimePicker
                  no-label
                  label="From date"
                  id="booking_date"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  v-model="reportFilters.bookingDate.from_date.date"
                  :only-date="true"
                  button-color="#ec391e"
                  color="#ec391e"
                  style="border: 1px solid #DFE5F9"
                />
                <small class="text-danger" v-if="reportFilters.bookingDate.from_date_error">{{ reportFilters.bookingDate.from_date_error }}</small>
              </div>
            </div>
            <div class="col-md-6">
              <div>
                <dateTimePicker
                  no-label
                  label="To date"
                  id="booking_date"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  v-model="reportFilters.bookingDate.to_date.date"
                  :only-date="true"
                  button-color="#ec391e"
                  color="#ec391e"
                  style="border: 1px solid #DFE5F9"
                  :min-date="reportFilters.bookingDate.from_date.date"
                />
                <small class="text-danger" v-if="reportFilters.bookingDate.to_date_error">{{ reportFilters.bookingDate.to_date_error }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer align-items-right">
      <button
        type="submit"
        class="button"
        v-on:click.prevent="getAffiliateReport"
      >
        Generate Report
      </button>
    </div>
  </div>
</template>
  
  <script>
  import axios from 'axios';
  export default {

    name: "AffiliateReportFields",
    data() {
      return {
        reportFilters : {
          affiliate : {
            selectedAffiliate: null,
            error: null
          },
          departureDates :{
            from_date:{},
            from_date_error:null,
            to_date:{},
            to_date_error:null
          },
          bookingDate :{
            from_date:{},
            from_date_error:null,
            to_date:{},
            to_date_error:null
          }
        },
        affiliates:[]
      };
    },
    mounted(){
      this.getAffiliates()
    },
    methods: {
      getAffiliateReport() {
        this.validateFields()
            .then((response) => {
              if(response){
                this.$store.dispatch("setLoadStatus");
                const request = {
                  affiliate: this.reportFilters.affiliate.selectedAffiliate,
                  departure_from_date: this.reportFilters.departureDates.from_date.date,
                  departure_to_date:this.reportFilters.departureDates.to_date.date,
                  booking_from_date: this.reportFilters.bookingDate.from_date.date,
                  booking_to_date:this.reportFilters.bookingDate.to_date.date,
                }
                fetch(this.$api + 'reports/affiliate-report', {
                  method: 'POST',
                  body: JSON.stringify(request),
                  headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                  }
                })
                .then((res) => {
                  if(res.status === 200) {
                    this.$store.dispatch('setLoadStatus')
                    res.blob().then(response => {
                      const _url = window.URL.createObjectURL(response)
                      const link = document.createElement('a')
                      link.href = _url
                      link.setAttribute('download', 'Affiliate-report.xlsx')
                      document.body.appendChild(link)
                      link.click();
                    })
                  } else {
                    this.$store.dispatch('setLoadStatus')
                    Promise.race([res.json()])
                    .then(response => {
                      if(response.message) {
                        this.$notify({
                          type: 'error',
                          title: response.message
                        });
                      } else {
                        this.$notify({
                          type: 'error',
                          title: response.error
                        });
                      }
                    })
                  }
                })
                
              }
            })
            .catch((error) => console.log(error))
      },
      getAffiliates() {
        axios.get(this.$api + 'affiliates?type=active',
        {
          headers:{
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then((response) => {
          if (response.data.success) {
            this.affiliates = response.data.data
          }
        });
      },
      validateFields(){
        let This = this
        return new Promise((resolve, reject) => {

          let errorCount = 0;
          
          // Affiliate Selection
          if(!This.reportFilters.affiliate.selectedAffiliate){
            This.reportFilters.affiliate.error = "Please select affiliate";
            errorCount +=1
          }else{
            This.reportFilters.affiliate.error = null
          } 

          // Departure Dates validation 
          if(This.reportFilters.departureDates.from_date.date && !This.reportFilters.departureDates.to_date.date) {
            This.reportFilters.departureDates.to_date_error = "Please select departure to date"
            errorCount +=1
          }else if(This.reportFilters.departureDates.to_date.date && !This.reportFilters.departureDates.from_date.date){
            This.reportFilters.departureDates.from_date_error = "Please select departure from date"
            errorCount +=1
          }else{
            This.reportFilters.departureDates.to_date_error = null
            This.reportFilters.departureDates.from_date_error = null
          }
          
          // Booking Dates validation
          if(This.reportFilters.bookingDate.from_date.date && !This.reportFilters.bookingDate.to_date.date) {
            This.reportFilters.bookingDate.to_date_error = "Please select booking to date"
            errorCount +=1
          }else if(This.reportFilters.bookingDate.to_date.date && !This.reportFilters.bookingDate.from_date.date){
            This.reportFilters.bookingDate.from_date_error = "Please select booking from date"
            errorCount +=1
          }else{
            This.reportFilters.bookingDate.to_date_error = null
            This.reportFilters.bookingDate.from_date_error = null
          }


          // Check for Departure date and Booking date
          if ( !This.reportFilters.departureDates.from_date.date && !This.reportFilters.bookingDate.from_date.date) 
          {
            This.reportFilters.departureDates.from_date_error = "Please select departure or booking date"
            This.reportFilters.bookingDate.from_date_error = "Please select booking or departure date"

            errorCount +=1
          }else{
            This.reportFilters.departureDates.from_date_error = null
            This.reportFilters.bookingDate.from_date_error = null
          }


          if(errorCount == 0 ){
            resolve(true)
          }else{
            reject(true)
          }

        })
      }
    }
  };
  </script>
  